<template>
  <eco-tree-list-dialog
    :single="single"
    :data="data"
    :table-columns="tableColumns"
    :pagination="pagination"
    :tree-data="treeData"
    :default-expanded-keys="['-1', '1']"
    dialog-title="选择接口"
    :append-to-body="appendToBody"
    @load="handleLoad"
    @loadListData="loadListData"
    @onConfirm="onConfirm"
    @reset="reset"
    quickSearchProps="NAME_"
    search-placeholder="接口名称"
    :destroy-on-close="destroyOnClose"
    ref="ecoTreeListDialog"
  />
</template>
<script>
import req from "@/request.js";
import portalApi from "@/api/portal.js";

export default {
  name: "eip-form-dialog",
  props: {
    value: Array,
    single: Boolean,
    name: String,
    formType: {
      type: String,
      default: "pc"
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    },
    roleAlias: {
      type: String
    }
  },
  data() {
    return {
      data: [],
      treeData: null,
      tableColumns: [
        { prop: "NAME_", label: "名称" },
        { prop: "ALIAS_", label: "别名" },
        { prop: "ACTION_TYPE_", label: "请求类别" },
        { prop: "REQUEST_URL_", label: "请求地址" }
      ],
      pagination: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      typeIdQuery: null
    };
  },
  mounted() {},
  methods: {
    loadTreeData() {
      portalApi.getMenuByRoleAlias(this.roleAlias).then(data => {
        this.treeData = data;
      });
    },
    showDialog() {
      this.loadTreeData();
      this.$refs.ecoTreeListDialog.showDialog();
    },
    handleLoad(param, cb) {
      if (this.typeIdQuery) {
        param.querys.push(this.typeIdQuery);
      }
      // 参数说明  url  requestBodyParam  requestParam
      req
        .post(
          "${form}/form/customDialog/v1/getListData?alias=jkffxz&mapParam=",
          param
        )
        .then(data => {
          let response = data.data;
          this.data = response.rows;
          if (this.data && this.data.length > 0) {
            this.data.forEach(ele => {
              if (ele.NAME_) {
                ele.name = ele.NAME_;
              }
              if (ele.ID_) {
                ele.id = ele.ID_;
              }
            });
          }
          this.pagination = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          };
        })
        .finally(() => cb());
    },
    loadListData(nodedata) {
      // 根据组织获取下级组织
      // 获取当前组织及下级组织
      let queryFilter = {
        pageBean: this.pagination,
        querys: []
      };
      this.typeIdQuery = {
        property: "path",
        value: nodedata.path,
        group: "categoryGroup",
        operation: "RIGHT_LIKE",
        relation: "AND"
      };
      this.handleLoad(queryFilter, () => {});
    },
    onConfirm(selection) {
      this.$emit("onConfirm", selection, this.name);
      this.$emit("input", selection);
    },
    reset() {
      /**
       * 点击重置按钮
       * 1. 清空树条件  this.typeIdQuery = "";
       * 2. 清空树选中状态
       * */
      if (this.typeIdQuery) {
        this.$refs.ecoTreeListDialog.$refs.tree.$refs.elTree.currentNode.node.isCurrent = false;
      }
      this.typeIdQuery = "";
    }
  }
};
</script>
